// import './axios'
// import './firebase'
// import './vue-touch'
import "./lazyload";
import "./animejs";



// WEBPACK FOOTER //
// ./src/plugins/index.js